/* ==========================================================================
   L'ACHAT DEPUIS LA CARTE — pont vers le moteur, toast riche, sélecteur.

   Trois responsabilités, une seule source de vérité (le panier serveur) :
   1. le clic « Ajouter » fabrique un vrai formulaire [data-add-form] et le
      soumet : le moteur testé garde ses garde-fous (bornes, 422, sections) ;
   2. après confirmation serveur, une NOTIFICATION riche apparaît en bas —
      photo, nom, lien panier — l'idée de la référence, dans notre langage ;
   3. le bouton rouge devient le sélecteur − / qté / + de la carte. « + »
      repasse par le moteur (mêmes gardes), « − » passe par cart/change.js
      avec la clé de ligne réelle. Tout affichage vient de cart.js relu.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Nash && window.Nash.root) || '/';
  var T = (window.Nash && window.Nash.i18n) || {};
  function t(cle, repli) { return T[cle] || repli; }

  /* ── état : variantId → { qty, key } relu depuis le serveur ───────────── */
  function lireEtat() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var par = {};
        (c.items || []).forEach(function (i) {
          var v = String(i.variant_id);
          if (!par[v]) par[v] = { qty: 0, key: i.key };
          par[v].qty += i.quantity;
        });
        return { count: c.item_count, par: par };
      });
  }

  function synchroniserCartes(etat) {
    document.querySelectorAll('[data-achat-cellule]').forEach(function (z) {
      var v = z.getAttribute('data-variant-id');
      var info = etat.par[v];
      var btn = z.querySelector('[data-add-to-cart]');
      var st = z.querySelector('[data-stepper]');
      if (!btn || !st) return;
      if (info && info.qty > 0) {
        btn.hidden = true;
        st.hidden = false;
        st.querySelector('[data-stepper-qte]').textContent = info.qty;
        var max = parseInt(z.getAttribute('data-max') || '', 10);
        var plus = st.querySelector('[data-stepper-plus]');
        if (plus) plus.disabled = !isNaN(max) && info.qty >= max;
      } else {
        btn.hidden = false;
        st.hidden = true;
      }
    });
  }

  /* ── la notification riche ────────────────────────────────────────────── */
  var toastTimer = null;
  function notifier(image, titre) {
    /* Le moteur affiche déjà son propre « Ajouté au panier » : deux toasts
       superposés au même endroit. Le riche remplace le simple. */
    var simple = document.querySelector('[data-toast]');
    if (simple) simple.className = 'toast';
    var z = document.querySelector('[data-nash-toast]');
    if (!z) {
      z = document.createElement('aside');
      z.setAttribute('data-nash-toast', '');
      z.className = 'nm-toast-achat';
      z.setAttribute('role', 'status');
      document.body.appendChild(z);
    }
    var proteger = function (x) {
      return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    };
    z.innerHTML =
      (image ? '<img class="nm-toast-achat__img" src="' + proteger(image) + '" alt="">' : '') +
      '<span class="nm-toast-achat__texte">' +
      '<strong>' + proteger(titre) + '</strong>' +
      '<span>' + t('toast.ajoute', 'Ajouté au panier') + '</span>' +
      '</span>' +
      '<a class="nm-toast-achat__lien" href="' + ROOT.replace(/\/$/, '') + '/cart">' +
      t('toast.voir_panier', 'Voir le panier') + '</a>';
    requestAnimationFrame(function () { z.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { z.classList.remove('is-visible'); }, 3800);
  }

  /* ── ajout via le moteur : formulaire réel soumis dans la carte ───────── */
  function ajouterViaMoteur(zone, image, titre) {
    var variantId = zone.getAttribute('data-variant-id');
    var form = document.createElement('form');
    form.setAttribute('data-add-form', '');
    form.setAttribute('method', 'post');
    form.setAttribute('action', ROOT + 'cart/add');
    form.hidden = true;
    var max = zone.getAttribute('data-max');
    if (max) form.dataset.inventoryMax = max;
    form.innerHTML = '<input type="hidden" name="id" value="' + variantId + '">' +
                     '<input type="hidden" name="quantity" value="1">';
    var envoi = document.createElement('button');
    envoi.type = 'submit';
    form.appendChild(envoi);
    (zone.closest('.nm-cell') || document.body).appendChild(form);
    if (typeof form.requestSubmit === 'function') form.requestSubmit(envoi);
    else envoi.click();

    setTimeout(function () {
      form.remove();
      lireEtat().then(function (etat) {
        synchroniserCartes(etat);
        photographier(etat);
        var info = etat.par[String(variantId)];
        if (info && info.qty > 0 && image !== null) notifier(image, titre);
      });
    }, 1400);
  }

  /* ── « − » : la clé de ligne réelle, puis re-synchronisation ──────────── */
  function retirerUn(zone) {
    var variantId = String(zone.getAttribute('data-variant-id'));
    lireEtat().then(function (etat) {
      var info = etat.par[variantId];
      if (!info) return synchroniserCartes(etat);
      return fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: info.key, quantity: Math.max(0, info.qty - 1) })
      }).then(function () { return lireEtat(); })
        .then(function (e2) {
          synchroniserCartes(e2);
          photographier(e2);
          var b = document.querySelectorAll('[data-cart-count]');
          b.forEach(function (x) { x.textContent = e2.count; });
        });
    });
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('[data-stepper-plus]');
    if (plus && !plus.disabled) {
      var z1 = plus.closest('[data-achat-cellule]');
      var b1 = z1 && z1.querySelector('[data-add-to-cart]');
      // + repasse par le moteur : mêmes bornes de stock, sans toast répété.
      if (z1) ajouterViaMoteur(z1, null, null);
      return;
    }
    var moins = e.target.closest && e.target.closest('[data-stepper-moins]');
    if (moins) {
      var z2 = moins.closest('[data-achat-cellule]');
      if (z2) retirerUn(z2);
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    if (btn.closest('[data-add-form]')) return;   // fiche produit : moteur seul
    e.preventDefault();
    var zone = btn.closest('[data-achat-cellule]');
    if (zone) {
      ajouterViaMoteur(zone, btn.getAttribute('data-image'), btn.getAttribute('data-titre'));
    }
  });

  /* ── LE PANIER RETROUVÉ ──────────────────────────────────────────────────
     Esprit Amazon : un client connecté ne repart jamais de zéro. À chaque
     changement, le contenu du panier est photographié sous une clé LIÉE AU
     COMPTE ; si, à une visite suivante, le client est connecté et son panier
     vide (cookie expiré, session nettoyée), la photographie est rejouée par
     cart/add.js — les articles disparus ou plafonnés sont simplement absorbés
     par le serveur, jamais bloquants.
     Limite assumée : la sauvegarde vit dans CE navigateur. La retrouver sur
     un autre appareil demanderait un service serveur — hors du thème. */
  var CLE_SAUVEGARDE = window.Nash && window.Nash.clientId
    ? 'nash-panier-' + window.Nash.clientId : null;

  function photographier(etat) {
    if (!CLE_SAUVEGARDE) return;
    try {
      var items = Object.keys(etat.par).map(function (v) {
        return { id: Number(v), quantity: etat.par[v].qty };
      }).filter(function (i) { return i.quantity > 0; });
      if (items.length) {
        localStorage.setItem(CLE_SAUVEGARDE,
          JSON.stringify({ quand: Date.now(), items: items }));
      } else {
        /* Panier vidé volontairement : l'instantané meurt avec lui, sinon
           il ressusciterait le panier à la visite suivante. */
        localStorage.removeItem(CLE_SAUVEGARDE);
      }
    } catch (e) { /* stockage plein ou bloqué : tant pis, sans bruit */ }
  }

  function restaurerSiVide(etat) {
    if (!CLE_SAUVEGARDE || etat.count > 0) return Promise.resolve(etat);
    /* Un panier VIDE n'est pas un panier PERDU. Si le cookie de panier est
       encore là, le client a simplement tout retiré : on ne restaure pas.
       (Relevé par la relecture : sans ce garde, vider son panier était
       impossible — il revenait à la page suivante.) */
    if (/(?:^|;\s*)cart=/.test(document.cookie)) return Promise.resolve(etat);
    var brut = null;
    try { brut = localStorage.getItem(CLE_SAUVEGARDE); } catch (e) {}
    if (!brut) return Promise.resolve(etat);
    var sauve;
    try { sauve = JSON.parse(brut); } catch (e) { return Promise.resolve(etat); }
    // au-delà de 30 jours, la photographie ne reflète plus une intention
    if (!sauve.items || !sauve.items.length ||
        Date.now() - (sauve.quand || 0) > 30 * 86400e3) {
      return Promise.resolve(etat);
    }
    /* Un instantané antérieur à la DERNIÈRE COMMANDE du client est mort :
       ces articles viennent d'être achetés — Shopify a consommé le panier.
       Sans ce garde, tout panier payé se re-remplissait au retour sur le
       site (relevé par la relecture). */
    var dernierOrdre = (window.Nash && window.Nash.dernierOrdre) || 0;
    if (dernierOrdre && (sauve.quand || 0) < dernierOrdre * 1000) {
      try { localStorage.removeItem(CLE_SAUVEGARDE); } catch (e) {}
      return Promise.resolve(etat);
    }
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: sauve.items })
    }).catch(function () {})
      .then(lireEtat)
      .then(function (e2) {
        if (e2.count > 0) {
          notifier(null, t('panier.restaure', 'Votre panier vous attendait'));
          var b = document.querySelectorAll('[data-cart-count]');
          b.forEach(function (x) { x.textContent = e2.count; });
        }
        return e2;
      });
  }

  /* ── LE PANIER TRANSFÉRÉ PAR LIEN ────────────────────────────────────────
     L'autre moitié du « panier qui suit le client » : le lien construit sur
     la page panier arrive ici avec ?nash-panier=variant:qte,… et FUSIONNE —
     pour chaque article, on vise max(déjà là, demandé), donc jamais de
     doublon ni d'effacement ; article par article, donc un produit disparu
     n'empêche jamais les autres ; l'URL est nettoyée AVANT les ajouts, donc
     un rechargement ne rejoue rien. Le serveur plafonne au stock réel. */
  function recupererDepuisLien(etat) {
    var m = /[?&]nash-panier=([^&#]+)/.exec(location.search);
    if (!m) return Promise.resolve(etat);
    /* Le lien voyage par messageries et navigateurs qui encodent — ou non —
       les deux-points et virgules. Constaté en test réel : %3A/%2C dans
       l'URL, et un decodeURIComponent qui levait sur une capture tronquée
       tuait toute la chaîne d'initialisation. On capture donc large, on
       décode si possible, et on ne lève JAMAIS. */
    var brut = m[1];
    try { brut = decodeURIComponent(brut); } catch (e) { /* déjà en clair */ }
    try {
      // seul nash-panier disparaît : les autres paramètres (aperçu, hash…)
      // appartiennent à la page et survivent.
      var q = location.search.replace(/[?&]nash-panier=[^&#]*/,'').replace(/^&/,'?');
      history.replaceState(null, '', location.pathname + q + location.hash);
    } catch (e) {}
    var chaine = Promise.resolve(), vus = {};
    brut.split(',').forEach(function (p) {
      var seg = p.split(':');
      var vid = parseInt(seg[0], 10), voulu = parseInt(seg[1], 10) || 0;
      if (!vid || voulu < 1 || vus[vid]) return;
      vus[vid] = 1;
      var deja = etat.par[String(vid)] ? etat.par[String(vid)].qty : 0;
      var delta = Math.min(voulu, 99) - deja;
      if (delta < 1) return;
      chaine = chaine.then(function () {
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: delta }] })
        }).catch(function () { /* disparu ou épuisé : les autres continuent */ });
      });
    });
    return chaine.then(lireEtat).then(function (e2) {
      if (e2.count > etat.count) {
        notifier(null, t('panier.recupere', 'Panier récupéré'));
        document.querySelectorAll('[data-cart-count]').forEach(function (x) {
          x.textContent = e2.count;
        });
      }
      return e2;
    });
  }

  /* le bouton « Envoyer le lien » de la page panier */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-panier-partager]');
    if (!b || b.disabled) return;
    lireEtat().then(function (etat) {
      var paires = Object.keys(etat.par).map(function (v) {
        return v + ':' + etat.par[v].qty;
      });
      if (!paires.length) return;
      var url = location.origin + ROOT + 'cart?nash-panier=' + paires.join(',');
      var confirme = function () {
        var initial = b.textContent;
        b.textContent = b.getAttribute('data-copie') || initial;
        b.disabled = true;
        setTimeout(function () { b.textContent = initial; b.disabled = false; }, 2600);
      };
      if (navigator.share) {
        navigator.share({ url: url }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(confirme, function () {});
      }
    });
  });

  /* au chargement : les cartes reflètent le panier existant */
  function init() {
    lireEtat()
      .then(recupererDepuisLien)
      .then(restaurerSiVide)
      .then(function (etat) {
        synchroniserCartes(etat);
        photographier(etat);
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
